/**
 * Helper puri sulla tassonomia categorie→sottocategorie del modulo Allenamenti,
 * condivisi tra il form del blocco (`week/useBlockForm`) e il filtro dell'analisi
 * (`analysis/useAnalysisFilter`): la cascata macro→sotto era scritta due volte.
 */
import { ITrainingCategory } from '../../models/allenamenti';

/** Sottocategoria pronta per un menu: slug + etichetta "Macro · Sotto" + colore. */
export interface ISubcategoriaOpzione {
  slug: string;
  labelIt: string;
  color: string;
}

/**
 * Sottocategorie delle macro selezionate, con l'etichetta della macro davanti
 * («Forza · Forza Massima»): senza il prefisso, con più macro scelte l'elenco
 * diventa un blocco di nomi di cui non si capisce a chi appartengono.
 */
export function subcategorieDelleMacro(
  categories: ITrainingCategory[],
  macroSlugs: string[],
): ISubcategoriaOpzione[] {
  return categories
    .filter((c) => macroSlugs.includes(c.slug))
    .flatMap((c) =>
      c.subcategories.map((s) => ({
        slug: s.slug,
        labelIt: `${c.labelIt} · ${s.labelIt}`,
        color: s.color,
      })),
    );
}

/** Slug delle sottocategorie ammesse dalle macro selezionate (per potare le orfane). */
export function sottoAmmesse(
  categories: ITrainingCategory[],
  macroSlugs: string[],
): Set<string> {
  return new Set(
    categories
      .filter((c) => macroSlugs.includes(c.slug))
      .flatMap((c) => c.subcategories.map((s) => s.slug)),
  );
}
